import {useFormContext} from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@common-web/components/ui/form';
import {Input} from '@common-web/components/ui/input';
import {CopyFromSection125} from '@client/pages/rfc/forms/components/CopyFromSection125';
import {ContactFields} from '@client/pages/rfc/forms/components/ContactFields';
import {PayrollVendorSelect} from '@client/pages/rfc/forms/components/PayrollVendorSelect';

export function MecPayroll({disableFormCopy}: {disableFormCopy?: boolean}) {
  const {control, getValues, setValue, watch} = useFormContext();
  const copyFromSection125 = () => {
    const src = getValues('section125Form.payrollInfo');
    if (src) {
      setValue('mecForm.payrollInfo', src, {shouldDirty: true, shouldValidate: true});
    }
  };

  return (
    <div className='space-y-6'>
      {!disableFormCopy && <CopyFromSection125 onCopy={copyFromSection125} />}
      <div>
        <ContactFields
          basePath={'mecForm.payrollInfo.contact'}
          titlePrefix={'Internal Payroll Contact (Optional)'}
          copySources={[
            {label: 'Payroll Vendor Contact', path: 'mecForm.payrollInfo.payrollVendorContact'},
          ]}
        />
      </div>
      <div>
        <ContactFields
          basePath={'mecForm.payrollInfo.payrollVendorContact'}
          titlePrefix={'Payroll Vendor Contact (Optional)'}
          copySources={[{label: 'Internal Payroll Contact', path: 'mecForm.payrollInfo.contact'}]}
        />
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <PayrollVendorSelect
          vendorPath={'mecForm.payrollInfo.vendor'}
          payrollSystemPath={'mecForm.payrollInfo.system'}
        />
        <FormField
          control={control}
          name={'mecForm.payrollInfo.payrollCompanyId'}
          render={({field}) => (
            <FormItem>
              <FormLabel>Payroll Company ID Number (Optional)</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
